;($ => {

    const pluginName = 'sideMenu';

    function Plugin(element, options) {

      options = $.extend({}, $.fn[pluginName].defaults, options);

      const
        el = element,
        $el = $(element),
        $toggler = $('.side-menu-toggler'),
        $hamburger = $('.hamburger', $toggler),
        cl = {
          togglerActive: 'is-active',
          openMenu: 'side-menu-open',
          menuItemSelected: 'active',
          menuItemGroup: 'side-menu-group'
        }
      ;

      function init() {
        $toggler.on('click', () => toggle());
        initItems();
        setCurrentPage(window.location.pathname);
        hook('onInit');
      }

      function initItems() {
        /*$('.side-menu-list a[data-toggle="collapse"]').on('click', e => {
          e.stopPropagation();
          const $this = $(e.target);
          toggleItemSubmenu($this.closest('.side-menu-list'), $this.closest('li'));
          return false;
        });*/
        /*Parche para no tener que reconstruir el plugin por un cambio de ultima hora*/
        $('.side-menu-list a[data-ref]').on('click', function() {
          var data_ref = $(this).data('ref');
          window.location.href = data_ref;
        });
      }

      /**
       * Set the current page (ie: buscador.html) to set active buttons
       * @param {String} pageName
       * @param {Function} done
       */
      function setCurrentPage(pageName, done = $.noop) {
        if ((pageName.match(/\//g) || []).length > 1){
          var page_route = pageName.split('/');
          pageName = page_route[page_route.length - 1];
        } else if (pageName[0] === '/'){
          pageName = pageName.slice(1);
        }

        let $btn = getButtonByPageName(pageName);
        const chain = [[$btn, getItemGroup($btn)]];
        do {
          const $group = getItemGroup($btn);
          const groupId = $group.attr('id');
          if (!groupId) break;
          $btn = getButtonByGroupId(groupId);
          if ($btn.length)
            chain.unshift([$btn, getItemGroup($btn)]);
        } while ($btn.length);
        (function openChain(chain) {
          if (!chain.length)
            return done();
          const [$btn, $menu] = chain.shift();
          openItemSubmenu($menu, $btn, () => openChain(chain));
        })(chain);
      }

      /**
       * Get a side menu item for a specific page name
       * @param {String} pageName
       * @returns {jQuery}
       */
      function getButtonByPageName(pageName) {
        return $(`[href="${pageName}"], [data-page="${pageName}"]`, $el).closest('li');
      }

      /**
       * Get a side menu item for a group
       * @param {String} groupId
       * @returns {jQuery}
       */
      function getButtonByGroupId(groupId) {
        return getButtonByPageName('#' + groupId);
      }

      /**
       * Get group of a specific item
       * @param {jQuery} $item
       * @returns {jQuery}
       */
      function getItemGroup($item) {
        return $item.closest('.' + cl.menuItemGroup);
      }

      function toggle(done = $.noop) {
        if (isOpen())
          close(done);
        else
          open(done);
      }

      function isOpen() {
        return $el.hasClass(cl.openMenu);
      }

      function open(done = $.noop) {
        $toggler.add($hamburger).addClass(cl.togglerActive);
        $el.addClass(cl.openMenu);
        done();
      }

      function close(done = $.noop) {
        $toggler.add($hamburger).removeClass(cl.togglerActive);
        $el.removeClass(cl.openMenu);
        done();
      }

      /**
       * Toggle visibility of the submenu related to a parent menu option
       * @param {jQuery} $parentMenu
       * @param {jQuery} $item
       */
      function toggleItemSubmenu($parentMenu, $item) {
        if ($item.hasClass(cl.menuItemSelected))
          closeSubmenuItem($parentMenu, $item);
        else
          openItemSubmenu($parentMenu, $item);
      }

      /**
       * Deploy the submenu related to a parent menu option
       * @param {jQuery} $parentMenu
       * @param {jQuery} $item
       * @param {Function} done
       */
      function openItemSubmenu($parentMenu, $item, done = $.noop) {
        const $selected = getSubmenuSelectedItem($parentMenu);
        closeSubmenuItem($parentMenu, $selected);
        const $submenu = getItemSubmenuCollapse($item);
        $item.addClass(cl.menuItemSelected);
        $submenu.collapse('show');
        setTimeout(done, 200);
      }

      /**
       * Collapse the submenu related to a parent menu option
       * @param {jQuery} $parentMenu
       * @param {jQuery} $item Parent menu option
       */
      function closeSubmenuItem($parentMenu, $item) {
        if (!$item.length) return;
        const $submenu = getItemSubmenuCollapse($item);
        if ($submenu.length) {
          const $selected = getSubmenuSelectedItem($submenu);
          if ($selected.length)
            closeSubmenuItem($submenu, $selected);
        }
        $item.removeClass(cl.menuItemSelected);
        $submenu.collapse('hide');
      }

      /**
       * Get the submenu current selected item
       * @param {jQuery} $menu
       * @returns {jQuery}
       */
      function getSubmenuSelectedItem($menu) {
        return $menu.find('li.' + cl.menuItemSelected);
      }

      /**
       * Get the submenu related to a parent menu item
       * @param {jQuery} $item
       * @returns {jQuery}
       */
      function getItemSubmenuCollapse($item) {
        const id = $('a', $item).attr('href');
        return $(id);
      }

      function option(key, val) {
        if (val) {
          options[key] = val;
        } else {
          return options[key];
        }
      }

      function destroy() {
        $el.each(() => {
          hook('onDestroy');
          $el.removeData('plugin_' + pluginName);
        });
      }

      function hook(hookName) {
        if (options[hookName] !== undefined) {
          options[hookName].apply(el, Array.prototype.slice.call(arguments).slice(1));
        }
      }

      init();

      return {
        option: option,
        destroy: destroy,
        toggle: toggle,
        isOpen: isOpen,
        open: open,
        close: close
      };
    }

    $.fn[pluginName] = function (options) {
      if (typeof arguments[0] === 'string') {
        const methodName = arguments[0];
        const args = Array.prototype.slice.call(arguments, 1);
        let returnVal;
        this.each(function () {
          if ($.data(this, 'plugin_' + pluginName) && typeof $.data(this, 'plugin_' + pluginName)[methodName] === 'function') {
            returnVal = $.data(this, 'plugin_' + pluginName)[methodName].apply(this, args);
          } else {
            throw new Error('Method ' + methodName + ' does not exist on jQuery.' + pluginName);
          }
        });
        if (returnVal !== undefined) {
          return returnVal;
        } else {
          return this;
        }
      } else if (typeof options === "object" || !options) {
        return this.each(function () {
          if (!$.data(this, 'plugin_' + pluginName)) {
            $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
          }
        });
      }
    };

    $.fn[pluginName].defaults = {
      onInit: $.noop,
      onDestroy: $.noop
    };

  }

)(jQuery);


// WEBPACK FOOTER //
// ./source/assets/javascripts/plugins/side-menu.js